var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-card-primary m-initial-setup"},[_c('p',[_vm._v("Initial Setup")])])
}]

export { render, staticRenderFns }